'use client';
import { useEffect, useState } from 'react';
import Icon from './Icon';
export default function MotionControl() {
 const [paused, setPaused] = useState(false);
 useEffect(() => () => { document.documentElement.classList.remove('motion-paused'); }, []);
 return <button className="motion-control" onClick={() => { document.documentElement.classList.toggle('motion-paused', !paused); setPaused(!paused); }} aria-pressed={paused} aria-label={paused ? 'Play decorative motion' : 'Pause decorative motion'}><Icon name={paused ? 'play' : 'pause'} width="13" height="13" /><span>{paused ? 'Motion paused' : 'Pause motion'}</span></button>;
}
